import { savePOI } from 'actions/pois';
import { getLocalization } from 'global/global';
import { useAppDispatch, useAppSelector } from 'index';
import { DashboardInterface } from 'Interfaces/DashBoardInterface';
import { DataPoint } from 'Interfaces/DataPoint';
import { StateInterface } from 'Interfaces/StateInterface';
import * as React from 'react';
import { Button } from 'react-bootstrap';
import FormComponent from 'views/SingleInstance/FormComponent';

interface Props {
  dataPoint: DataPoint;
  dashboard: DashboardInterface;
  onRemoveDataPoint: (dashboardId: number, dataPointId: string) => void;
  onDataPointUpdated: (dataPoint: DataPoint) => void;
}

export default function DashboardDataPoint(props: Props) {
  const dispatch = useAppDispatch();
  const clientPersist = useAppSelector(state => state.clientPersist);
  const forms = useAppSelector((state: StateInterface) => state.forms.collection);

  const formComponent = React.useRef<FormComponent | null>(null);

  const { dataPoint } = props;
  const saveDataPoint = async () => {
    if (formComponent?.current) {
      const dp = formComponent.current.getDataModel();
      const saved = await dispatch(savePOI(dp));
      const json = await saved.json();
      console.log(json);
      if (json.dataPoint) {
        props.onDataPointUpdated(json.dataPoint);
      }
    }
  };

  return (
    <div className="col dashboard-chart-container">
      <div className={`d-flex ms-2 me-2 mb-2 justify-content-between`}>
        <Button
          size="sm"
          onClick={() => void saveDataPoint()}
          variant={'primary'}
        >
          <i className="fa fa-save"/>
          {` ${getLocalization('refresh')}`}
        </Button>
        <Button
          size="sm"
          onClick={() => props.onRemoveDataPoint(props.dashboard.id, `${dataPoint.id}`)}
          variant={'danger'}
        >
          <i className="fa fa-trash"/>
        </Button>
      </div>
      <FormComponent
        ref={formComponent}
        dataPoint={dataPoint}
        forms={forms}
        clientPersist={clientPersist}
        model={forms.find(f => f.ref === dataPoint.questionnaire_id) || {}}
        readOnly={false}
      />
    </div>
  );
}
